module.exports = __webpack_public_path__ + "static/media/spin_cash500.0c98606b.png";